var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    x: 0.5,
    y: 0.5,
    fill: "#FEEBF0",
    rx: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E31C4C",
    fillRule: "evenodd",
    d: "M13.508 7.6a1.25 1.25 0 0 0-1.015 0c-.109.048-.274.173-.553.567-.277.391-.598.944-1.06 1.742l-2.7 4.663c-.463.801-.784 1.357-.986 1.793-.203.44-.23.647-.218.765.037.352.222.672.508.881.096.07.288.15.77.194.48.044 1.121.045 2.047.045h5.4c.924 0 1.566 0 2.045-.045.483-.044.675-.124.77-.194a1.25 1.25 0 0 0 .509-.881c.012-.118-.015-.325-.218-.765-.202-.436-.523-.992-.986-1.793l-2.7-4.663c-.462-.798-.783-1.35-1.06-1.742-.28-.394-.445-.52-.553-.567m-1.625-1.371a2.75 2.75 0 0 1 2.235 0c.485.216.843.614 1.167 1.071.321.454.676 1.067 1.115 1.825l.019.033 2.7 4.663.019.033c.44.76.796 1.375 1.03 1.882.236.51.404 1.02.349 1.55a2.75 2.75 0 0 1-1.118 1.938c-.43.313-.956.424-1.516.475-.555.051-1.267.051-2.145.051h-5.475c-.879 0-1.59 0-2.145-.051-.56-.051-1.086-.162-1.516-.475a2.75 2.75 0 0 1-1.118-1.939c-.055-.529.113-1.04.349-1.55.234-.506.59-1.121 1.03-1.881l.02-.033 2.699-4.663.02-.033c.438-.757.793-1.37 1.114-1.825.324-.457.682-.855 1.167-1.071M13.001 10a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3A.75.75 0 0 1 13 10m0 6.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5",
    clipRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    x: 0.5,
    y: 0.5,
    stroke: "#E31C4C",
    rx: 7.5
  })));
};
export default SvgError;